import { useState } from 'react'
import RecipeThumbnail from '../../../../../assets/insights/RecipeThumbnail.svg'
import ScoopLogo from '../../../../../assets/common/NewLogo.svg'
import { ScoopSearchBar, ScoopChip, ScoopText } from '../../../../ui'
import styles from './ChooseRecipe.module.scss'

export const ChooseRecipe = ({ selectRecipe }) => {
    const categories = [
        'All',
        'Sales',
        'Marketing',
        'Lead Generation',
        'Customer Success',
        'Finance',
        'Product Analysis',
        'Services',
    ]
    const recipes = [
        {
            img: RecipeThumbnail,
            department: 'Marketing',
            title: 'Deal velocity',
            description:
                'This recipe provides you with average time between stages and is filterable by any field available within the data source. These filters allow you look at deal velocity by fields like Deal Owner, Deal Source and Deal Type.',
            stats: ['1 dataset', '2 canvases'],
        },
        {
            img: RecipeThumbnail,
            department: 'Finance',
            title: 'Budget Analysis',
            description:
                'This recipe analyzes your budget data and provides insights into spending trends, allocation efficiency, and budget performance over time.',
            stats: ['3 datasets', '1 canvas'],
        },
        {
            img: RecipeThumbnail,
            department: 'Human Resources',
            title: 'Employee Satisfaction',
            description:
                'This recipe measures employee satisfaction through surveys and analyzes the results to identify areas for improvement and track changes over time.',
            stats: ['2 datasets', '3 canvases'],
        },
        {
            img: RecipeThumbnail,
            department: 'Operations',
            title: 'Inventory Optimization',
            description:
                'This recipe helps optimize inventory levels by analyzing historical data, demand forecasts, and supply chain disruptions to ensure efficient inventory management.',
            stats: ['2 datasets', '2 canvases'],
        },
        {
            img: RecipeThumbnail,
            department: 'Customer Service',
            title: 'Customer Feedback Analysis',
            description:
                'This recipe analyzes customer feedback from various channels such as surveys, reviews, and social media to identify trends, sentiment, and areas for improvement in customer service.',
            stats: ['3 datasets', '2 canvases'],
        },
        {
            img: RecipeThumbnail,
            department: 'Product Development',
            title: 'Feature Prioritization',
            description:
                'This recipe prioritizes product features based on customer feedback, market demand, and strategic goals to optimize product development efforts and maximize impact.',
            stats: ['2 datasets', '1 canvas'],
        },
        {
            img: RecipeThumbnail,
            department: 'Sales',
            title: 'Pipeline Analysis',
            description:
                'This recipe analyzes the sales pipeline to identify bottlenecks, opportunities, and potential risks, enabling better sales forecasting and decision-making.',
            stats: ['3 datasets', '2 canvases'],
        },
    ]

    const [categorySelected, setCategorySelected] = useState('All')

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.logoWrapper}>
                    <img alt="scoop-logo" src={ScoopLogo} />
                </div>
                <div className={styles.textContent}>
                    <ScoopText className={styles.title}>Scoop Recipes</ScoopText>
                    <ScoopText className={styles.description}>
                        These ready-made templates provide inspiration with just a few clicks.
                        <br />
                        Connect them to your own data sources and start customising.
                    </ScoopText>
                </div>
                <div className={styles.searchWrapper}>
                    <ScoopSearchBar placeholder="Search recipes" className={styles.searchBar} />
                </div>
            </div>
            <div className={styles.contentWrapper}>
                <div className={styles.categoriesContainer}>
                    <ScoopText className={styles.categoriesTitle}>Categories</ScoopText>
                    <div>
                        {categories.map((category, index) => (
                            <div
                                key={index}
                                className={`${styles.categoryItem} ${categorySelected === category ? styles.active : ''}`}
                                onClick={() => setCategorySelected(category)}
                            >
                                <ScoopText className={styles.categoryText}>{category}</ScoopText>
                            </div>
                        ))}
                    </div>
                </div>
                <div className={styles.recipesGrid}>
                    {recipes.map((recipe, index) => (
                        <RecipeCard selectRecipe={selectRecipe} key={index} recipe={recipe} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export const RecipeCard = ({ recipe, selectRecipe }) => {
    return (
        <div className={styles.recipeCard} onClick={() => selectRecipe(recipe)}>
            <div className={styles.cardImage}>
                <img alt={recipe.title} src={recipe.img} />
            </div>
            <div className={styles.cardContent}>
                <div>
                    <ScoopChip label={recipe.department} className={styles.departmentChip} />
                </div>
                <div className={styles.cardDetails}>
                    <ScoopText className={styles.cardTitle}>{recipe.title}</ScoopText>
                    <ScoopText className={styles.cardDescription}>{recipe.description}</ScoopText>
                </div>
                <div className={styles.statsContainer}>
                    {recipe.stats.map((stat, index) => (
                        <ScoopChip label={stat} key={index} />
                    ))}
                </div>
            </div>
        </div>
    )
}
